export const MODULE_NAME = 'audience-insights';
export const AUDIENCE_INSIGHTS_ROUTE = `/${MODULE_NAME}`;
